/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMLoginOpenPayload } from '@/data/types/GTM';

export const getGTMLoginOpenEventData = (payload: GTMLoginOpenPayload) => ({
	login_step: 0,
	login_origin: payload.login_origin,
});
